import React, { useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import {
  Card,
  Col,
  DatePicker,
  Row,
  Statistic,
  StatisticProps,
  Table,
} from "antd";
import dayjs from "dayjs";
import {
  ArrowUpOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  endOfDay,
  endOfMonth,
  format,
  parseISO,
  startOfDay,
  startOfMonth,
} from "date-fns";
import { useTranslation } from "react-i18next";
import { calculateMonthlyHours } from "../../utils";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_API_URL } from "../../../../utils/consts";
import { useParams } from "react-router-dom";
import "./UserPayment.scss";
type Props = {
  userDetails: any;
  onChangeDate: (date: any) => void;
};
interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

type Entry = {
  status: string;
  _id: string;
  userId: string;
  from: string;
  to: string;
  duration: number; // duration u minutama
  hourly_rate: number;
  pay_multiplier: number;
};

const UserPayment: React.FC<Props> = ({ userDetails, onChangeDate }) => {
  const [selectedMonth, setSelectedMonth] = useState<any>(dayjs(new Date()));
  const [totalEarned, setTotalErned] = useState<any>(0);
  const [userOvertimePayment, setUserOvertimePayment] =
    useState<any>(undefined);
  const userData = useSelector((state: any) => state.userData.user);
  const params = useParams();
  const { t } = useTranslation();

  const paymentDetails: any = userDetails?.patientDetails
    ? []?.concat(
        ...userDetails?.patientDetails?.map((item: any) => item.notes)
      ) ?? []
    : [];
  useEffect(() => {
    setTotalErned(calculateTotalCosts(userDetails?.patientDetails));
  }, [userDetails]);

  useEffect(() => {
    // const date = parseISO(selectedMonth);

    const start = startOfMonth(new Date(selectedMonth));
    const end = endOfMonth(new Date(selectedMonth));
    axios
      .get(
        `${BASE_API_URL}/${params.id}/user_details_payments/${startOfDay(
          new Date(start).toISOString()
        )}/${endOfDay(new Date(end).toISOString())}`,
        {
          params: {
            // userId: params.id,
          },
        }
      )
      .then((res) => {
        console.log("res", res);
        setUserOvertimePayment(res.data);
        // setOvertimes(res.data);
      })
      .catch((error) => console.error(error));
  }, [params.id, selectedMonth]);

  console.log("selectedMonth", selectedMonth);
  const calculateTotalCosts = (data: any) => {
    let totalCosts = 0;
    // Loop through each patient's notes
    data?.forEach((patient: any) => {
      if (patient.notes) {
        patient?.notes?.forEach((note: any) => {
          // Add the costs to the total
          totalCosts += note.costs || 0;
        });
      }
    });
    return totalCosts;
  };

  const calculateCurrency = () => {
    if (userDetails?.user.clientId.currency === "Dinar") {
      return "RSD";
    } else if (userDetails?.user.clientId.currency === "Euro") {
      return "EUR";
    } else {
      return "$";
    }
  };
  const calculatePercentage = (value: any) => {
    const percentage = userDetails?.user?.amount ?? 30;
    return (percentage / 100) * value;
  };

  const columns: ColumnsType<DataType> = [
    {
      title: t("Costs"),
      dataIndex: "costs",
      key: "costs",
      render: (text) => (
        <>
          {text} {calculateCurrency()}
        </>
      ),
    },
    {
      title: t("Date"),
      dataIndex: "date",
      width: 150,
      key: "date",
      render: (value, row) => {
        return format(new Date(value), "d-MMM-yyyy");
      },
    },
    {
      title: t("Title"),
      dataIndex: "title",
      key: "title",
    },
    {
      title: t("Description"),
      dataIndex: "description",
      key: "description",
    },
  ];

  const handlePrevMonth = () => {
    setSelectedMonth(selectedMonth.subtract(1, "month"));
    onChangeDate(selectedMonth.subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setSelectedMonth(selectedMonth.add(1, "month"));
    onChangeDate(selectedMonth.add(1, "month"));
  };

  function calculateDetailedPayments(entries: Entry[]) {
    const groupedByMultiplier: Record<number, { hours: number; pay: number }> =
      {};
    let totalHours = 0;
    let totalPay = 0;

    entries?.forEach((entry) => {
      const hours = entry.duration / 60;
      const pay = hours * entry.hourly_rate * entry.pay_multiplier;

      if (!groupedByMultiplier[entry.pay_multiplier]) {
        groupedByMultiplier[entry.pay_multiplier] = { hours: 0, pay: 0 };
      }

      groupedByMultiplier[entry.pay_multiplier].hours += hours;
      groupedByMultiplier[entry.pay_multiplier].pay += pay;

      totalHours += hours;
      totalPay += pay;
    });

    const averageRate = totalHours > 0 ? totalPay / totalHours : 0;

    return {
      groupedByMultiplier,
      totalHours,
      totalPay,
      averageRate,
    };
  }

  console.log(
    "calculateDetailedPayments(entries)",
    calculateDetailedPayments(userOvertimePayment)
  );

  return (
    <div className="userProfilePayment">
      {/* <div>
        <label>{t("Select month")} </label>
        <DatePicker
          picker="month"
          allowClear={false}
          defaultValue={dayjs(new Date())}
          //   disabledDate={disabledDate}
          onChange={(date: any, dateString: string) => {
            setSelectedMonth(dateString);
            onChangeDate(dateString);
          }}
        />
      </div> */}
      <div className="homeDatePicker">
        <div className="prev" onClick={handlePrevMonth}>
          <LeftOutlined />
        </div>
        <div className="date">
          <DatePicker
            picker="month"
            allowClear={false}
            value={selectedMonth}
            format={"MM-YYYY"}
            //   disabledDate={disabledDate}
            onChange={(date: any, dateString: any) => {
              setSelectedMonth(date);
              onChangeDate(new Date(date));
            }}
          />
        </div>
        <div className="next" onClick={handleNextMonth}>
          <RightOutlined />
        </div>
      </div>
      <div className="overtimeEarnings">
        <Row gutter={16}>
          <Col span={12}>
            <Card bordered={false}>
              <Statistic
                title={`${t("Total Overtime Hours")} `}
                value={
                  calculateDetailedPayments(
                    userOvertimePayment
                  ).totalHours.toFixed(1) ?? 0
                }
                suffix={t("Hours")}
                valueStyle={{ color: "#3f8600" }}
              />
            </Card>
          </Col>
          <Col span={12}>
            <Card bordered={false}>
              <Statistic
                title={`${t("Total earnings for overtime work")}`}
                value={
                  calculateDetailedPayments(
                    userOvertimePayment
                  ).totalPay.toFixed(1) ?? 0
                }
                suffix={calculateCurrency()}
                valueStyle={{ color: "#3f8600" }}
                precision={2}
              />
            </Card>
          </Col>
        </Row>
      </div>
      <Row>
        <Col xs={24}>
          {userDetails?.user?.workingPatternId?.type === "HOURLY" ? (
            <>
              <Row gutter={16} className="paymentResults">
                <Col md={8} sm={24}>
                  <Card bordered={false}>
                    <Statistic
                      title={t("Total hours")}
                      value={Number(
                        calculateMonthlyHours(
                          userDetails?.user?.workingPatternId?.weekdays,
                          selectedMonth
                        )
                      )}
                      precision={1}
                      valueStyle={{ color: "#3f8600" }}
                      prefix={<ArrowUpOutlined />}
                      //   suffix={t("Hours")}
                    />
                  </Card>
                </Col>
                <Col md={8} sm={24}>
                  <Card bordered={false}>
                    <Statistic
                      title={t("Hourly rate")}
                      value={Number(userDetails?.user.amount)}
                      precision={1}
                      valueStyle={{
                        color: "#3f8600",
                      }}
                      // prefix={renderNeedToPaidIcon()}
                      suffix={calculateCurrency()}
                    />
                  </Card>
                </Col>
                <Col md={8} sm={24}>
                  <Card bordered={false}>
                    <Statistic
                      title={t("Earnings without overtime")}
                      value={
                        Number(userDetails?.user.amount) *
                        Number(
                          calculateMonthlyHours(
                            userDetails?.user?.workingPatternId?.weekdays,
                            selectedMonth
                          )
                        )
                      }
                      precision={1}
                      valueStyle={{
                        color: "#3f8600",
                      }}
                      // prefix={renderNeedToPaidIcon()}
                      suffix={calculateCurrency()}
                    />
                  </Card>
                </Col>
              </Row>
            </>
          ) : userDetails?.user?.workingPatternId?.type === "FIXED" ? (
            <>
              <Row gutter={16} className="paymentResults">
                <Col md={24} sm={24}>
                  <Card bordered={false}>
                    <Statistic
                      title={t("Monthly salary")}
                      value={Number(userDetails?.user.amount)}
                      precision={1}
                      valueStyle={{
                        color: "#3f8600",
                      }}
                      // prefix={renderNeedToPaidIcon()}
                      suffix={calculateCurrency()}
                    />
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      {userDetails?.user?.workingPatternId?.type === "PERCENT" ? (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title={t("Total Earnings")}
                  value={totalEarned}
                  precision={1}
                  valueStyle={{ color: "#3f8600" }}
                  prefix={<ArrowUpOutlined />}
                  suffix={calculateCurrency()}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title={
                    t("Earnings of the employee") +
                    ` ${userDetails?.user?.amount ?? 30}%`
                  }
                  value={calculatePercentage(totalEarned)}
                  precision={1}
                  valueStyle={{ color: "#3f8600" }}
                  prefix={<ArrowUpOutlined />}
                  suffix={calculateCurrency()}
                />
              </Card>
            </Col>
          </Row>
          {/* <div className="userPaymentList">
        {paymentDetails?.map((item: any) => {
          return (
            <div className="list">
              <div className="payment">
                <div className="icon">
                  <CalendarOutlined />
                </div>
                <div className="date">
                  {format(new Date(item.date), "d-MMM-yyyy")}
                </div>
                <div className="title">
                  <div>{item.title}</div>
                </div>
              </div>
              <div className="costs">{item.costs}</div>
            </div>
          );
        })}
      </div> */}
          <Table columns={columns} dataSource={paymentDetails} />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default UserPayment;
